import React, { useRef, useState } from "react";

import {
  Box,
  Button,
  DialogTitle,
  makeStyles,
  Stepper,
  Step,
  StepLabel,
  Typography,
  DialogContent,
  DialogActions,
} from "@material-ui/core";

import useLocale from "../../../../hooks/useLocale";
import { useQuery } from "react-query";
import CustomAlert from "../../../components/CustomAlert";
import CustomDialog from "../../../components/CustomDialog";

import { fetchPortNames } from "../../../../services/portNamesServices";

import Sailor from "./SearchSailor";
import AddSailorDetails from "./AddSailorDetails";

const useStyles = makeStyles(({ theme }) => ({
  searchBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  searchButton: {
    width: "80%",
    height: "100%",
    fontSize: "1rem",
  },
  root: {
    width: "100%",
  },
  backButton: {
    marginRight: "1rem",
  },
  instructions: {
    margin: "1rem",
  },
  buttonBox: {
    margin: "1rem",
    display: "flex",
    justifyContent: "space-between",
  },
}));

function CreateDialog({ open, close, refetch, crewlist }) {
  const classes = useStyles();
  const { t } = useLocale();
  const [error, setError] = useState("");
  const [errorSailor, setErrorSailor] = useState("");

  const [selectedSailor, setSelectedSailor] = useState("");

  const submitRef = useRef();

  const getSteps = () => {
    return [t("Select Sailor"), t("Fill Sailor Ship Details")];
  };

  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return t("Select Sailor");
      case 1:
        return t("Fill Sailor Ship Details");
      default:
        return "Unknown stepIndex";
    }
  };

  const { data: portNames } = useQuery("portNames", fetchPortNames);

  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      refetch();
      close();
      setActiveStep(0);
      return;
    }
    if (!selectedSailor) {
      setErrorSailor(t("Please select one Sailor"));
      return;
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setSelectedSailor("");
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSubmitForm = () => {
    if (submitRef.current && submitRef.current.initialValues.isValid) {
      submitRef.current.handleSubmit();
    } else {
      submitRef.current.handleSubmit();
    }
  };

  return (
    <>
      <CustomDialog
        open={open}
        onClose={close}
        aria-labelledby="form-dialog-title"
        maxWidth="md"
      >
        <DialogTitle id="form-dialog-title">
          {t("Add new Crew Person Data")}
        </DialogTitle>
        <DialogContent>
          <CustomAlert
            open={!!error}
            close={() => {
              setError("");
            }}
            message={t("A network error occured, please try again later")}
          />
          <CustomAlert
            open={!!errorSailor}
            close={() => {
              setErrorSailor("");
            }}
            message={errorSailor}
          />
          <div className={classes.root}>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <div>
              {
                activeStep !== steps.length && (
                  <div>
                    <Typography className={classes.instructions}>
                      {getStepContent(activeStep)}
                    </Typography>
                    <div>
                      {activeStep === 0 && (
                        <Sailor
                          setErrorSailor={setErrorSailor}
                          setSelectedSailor={setSelectedSailor}
                        />
                      )}
                      {activeStep === 1 && (
                        <AddSailorDetails
                          selectedSailor={selectedSailor}
                          setError={setError}
                          ref={submitRef}
                          crewlist={crewlist}
                          refetch={refetch}
                          finishStepper={() => setActiveStep(0)}
                          close={close}
                        />
                      )}
                    </div>
                  </div>
                )
                // )
              }
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Box className={classes.buttonBox}>
            <Button
              color="primary"
              disabled={activeStep === 0}
              onClick={handleBack}
              className={classes.backButton}
            >
              {t("Back")}
            </Button>
            {activeStep === steps.length - 1 ? (
              <Box>
                <Button
                  style={{ marginRight: "1rem" }}
                  color="primary"
                  disabled={errorSailor ? true : false}
                  onClick={handleSubmitForm}
                >
                  {t("Add")}
                </Button>
                <Button
                  color="primary"
                  disabled={errorSailor ? true : false}
                  onClick={handleNext}
                >
                  {t("Close")}
                </Button>
              </Box>
            ) : (
              <Button
                color="primary"
                disabled={errorSailor ? true : false}
                onClick={handleNext}
              >
                {t("Next")}
              </Button>
            )}
          </Box>
        </DialogActions>
      </CustomDialog>
    </>
  );
}

export default CreateDialog;
